/**
 * Convert dashboard title to URL slug
 * "My New Dashboard" -> "my-new-dashboard"
 */
export function nameToSlug(title: string): string {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '') // Remove leading/trailing hyphens
}

/**
 * Get dashboard URL by title
 */
export function getDashboardUrl(title: string): string {
  const slug = nameToSlug(title)
  return `/dash/${slug}`
}

/**
 * Get dashboard URL by dashboard object
 */
export function getDashboardUrlFromDashboard(dashboard: { title: string }): string {
  return getDashboardUrl(dashboard.title)
}
